"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@8base-react/utils");
const AuthContext_1 = require("./AuthContext");
const withAuth = (WrappedComponent) => { var _a; return _a = class WithAuth extends react_1.default.Component {
        render() {
            return (react_1.default.createElement(AuthContext_1.AuthContext.Consumer, null, auth => react_1.default.createElement(WrappedComponent, Object.assign({}, this.props, { auth: auth || {} }))));
        }
    },
    _a.displayName = `withAuth(${utils_1.getDisplayName(WrappedComponent)})`,
    _a; };
exports.withAuth = withAuth;
//# sourceMappingURL=withAuth.js.map